import { Component, AfterViewInit, OnDestroy, OnInit, HostListener, TemplateRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ClientIntake } from '../../../models/client-intake';

import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { HttpClientService } from '../../../services/common/http-client.service';
import { ClientIntakeService } from '../../../services/client_intakes/client-intake.service';
import { ModalService } from '../../../services/common/modal.service';
import { NotyService } from '../../../services/common/noty.service';
import { RruleService } from '../../../services/events/rrule.service';

declare let moment: any;

@Component({
  selector: 'app-client-intake-index',
  templateUrl: './client-intake-index.component.html',
  styleUrls: ['./client-intake-index.component.scss'],
})
export class ClientIntakeIndexComponent implements AfterViewInit, OnDestroy, OnInit {
  /**
   * Client intakes search results for current page
   * @type {Array<ClientIntake>}
   */
  clientIntakes: Array<ClientIntake> = [];

  clientIntake: any = {};

  /**
   * ID input for show modal
   * @type {number}
  */
  clientIntakeId: number;

  /**
   * Count of total client intakes of search result
   * @type {number}
   */
  count: number = 0;

  /**
   * Indicates if search request is being proccessed
   * @type {boolean}
   */
  searching: boolean = false;

  /**
   * Search options for sidebar
   * @type {any}
   */
  searchOptions: any = {
    attorneys: [],
    date_ranges: [],
    deleted: [],
    matter_types: [],
    order_by: [],
    order_of: [],
    priorities: [],
    referral_types: [],
    users: [],
  };

  clientIntakeFormEditMode: boolean = false;

  isChildModalOpen: boolean = false;

  /**
   * Search params for search request
   * @type {any}
   */
  searchParams: any = {
    per_page: 25,
    page: 1
  };

  defaultSearchParams: any = {};

  /**
   * Indicates if sidebar is to be maximized
   * @type {boolean}
   */
  sidebarMaximized: boolean = false;

  /**
   * Indicates if sidebar is to be shown for smaller width screens
   * @type {boolean}
   */
  sidebarOpen: boolean = false;

  componentDestroyed: boolean = false;

  sidebarTimeouts: Array<any> = [];

  @ViewChild('clientIntakeShowtemplate') clientIntakeShowtemplate: TemplateRef<any>;

  childTemplate: TemplateRef<any>;

  /**
   * Constructor
   * @param {ClientIntakeService} private clientIntakeService Service to access client intakes controller
   * @param {NotyService}    private notyService    Notifications service for web UI
  */

  clinetIntakeFormModalRef?: BsModalRef;

  clinetIntakeShowModalRef?: BsModalRef;

  constructor(public httpClientService: HttpClientService, public router: Router, public route: ActivatedRoute, public clientIntakeService: ClientIntakeService, public modalService: BsModalService, public notyService: NotyService) {}

  ngOnInit() {
    let today: string = moment().format('D MMM YYYY');
    Object.assign(this.searchParams, this.route.snapshot.queryParams);
    return this.clientIntakeService.searchOptions().then((response_json) => {
      if(this.componentDestroyed) return;
      this.searchOptions = response_json.search_options || {};
      // Merge instead of replace to preserve defaults
      Object.assign(this.searchParams, response_json.default_options || {});
      Object.assign(this.defaultSearchParams, response_json.default_options || {});
      this.selectDateRange();
      this.search(null, true);
    }).catch((error) => {
      if(this.componentDestroyed) return;
      console.error(error);
    });
  }

  /**
   * Called after HTML is initialized
   */
  ngAfterViewInit() {
    this.sidebarTimeouts.push(setTimeout(() => {
      if(this.componentDestroyed) return;
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 500));
    this.sidebarTimeouts.push(setTimeout(() => {
      if(this.componentDestroyed) return;
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 5000));
  }

  ngOnDestroy() {
    this.componentDestroyed = true;
    this.sidebarTimeouts.forEach(timeout => clearTimeout(timeout));
  }

  clearSearch() {
    if(this.componentDestroyed) return;
    this.searchParams = { per_page: 25, page: 1 };
    Object.assign(this.searchParams, this.defaultSearchParams || {});
    this.selectDateRange();
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
    this.search();
  }

  openClientIntakeModal(template: TemplateRef<any>, shouldOpenClientIntakeForm: boolean) {
    this.isChildModalOpen = true;
    const body = document.body;
    body.style.overflow = "hidden";
    if(shouldOpenClientIntakeForm){
      this.clinetIntakeFormModalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-lg', ignoreBackdropClick: true, backdrop: true }))
    }
    else{
      this.clinetIntakeShowModalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-lg', ignoreBackdropClick: true, backdrop: true }))
    }
  }

  onClientIntakeModalClose(event: any, shouldCloseFormModal: boolean) {
    if(this.componentDestroyed) return;
    if(event.shouldClose){
      const body = document.body;
      body.style.overflow = "auto";
      this.isChildModalOpen = false;
      if(shouldCloseFormModal){
        this.clinetIntakeFormModalRef?.hide();
        if(event.clientSaveSuccess){
          this.clientIntakeId = event.id
          this.openClientIntakeModal(this.clientIntakeShowtemplate, false);
        }
      }
      else{
        this.clinetIntakeShowModalRef?.hide()
      }
    }
    this.search();
  }
  /**
   * Page changed
   * @param {any} $event Page change event with new page number
   */
  pageChanged($event: any) {
    if(this.componentDestroyed) return;
    this.searchParams.page = $event.page;
    this.search();
  }

  selectDateRange(){
    let today = moment().format('L')
    const dateRange: any = {
      "Today": () => {
        this.searchParams.date_from = this.searchParams.date_to = today
      },
      "Yesterday": () => {
        this.searchParams.date_from = this.searchParams.date_to = moment().subtract(1, 'days').format('L')
      },
      "Last 30 days": () => {
        this.searchParams.date_from = moment().subtract(30, 'days').calendar()
        this.searchParams.date_to = today
      },
      "Last 60 days": () => {
        this.searchParams.date_from = moment().subtract(60, 'days').calendar()
        this.searchParams.date_to = today
      },
      "Last 90 days": () => {
        this.searchParams.date_from = moment().subtract(90, 'days').calendar()
        this.searchParams.date_to = today
      },
      "Custom Range": () => {
        this.searchParams.date_from = this.searchParams.date_to = ""
      }
    };
    // Check if date_range exists and has a handler
    if (this.searchParams.date_range && dateRange[this.searchParams.date_range]) {
      (dateRange[this.searchParams.date_range])();
      console.table({fromDate: this.searchParams.date_from, toDate: this.searchParams.date_to})
    }
  }

  /**
   * Process search request
   */
  search(pageEvent: any = null, isSearching: boolean = false) {
    if(this.componentDestroyed) return Promise.resolve();
    if (isSearching)
      this.searching = true;
    if (pageEvent) this.searchParams.page = pageEvent.page;
    // this.searchParams.date_from = moment(this.searchParams.date_from).format('L')
    // this.searchParams.date_to = moment(this.searchParams.date_to).format('L')
    return this.clientIntakeService
      .index(this.searchParams)
      .then((response_json) => {
        if(this.componentDestroyed) return;
        console.log("search response", response_json)
        this.clientIntakes = response_json.client_intakes || [];
        this.count = response_json.count || 0;
        if (isSearching)
          this.searching = false;
        let newPageUrl: string = this.httpClientService.buildNewPageUrl(this.clientIntakeService.url, this.searchParams);
        if(window.location.href != newPageUrl)
          this.httpClientService.setNewPageUrl(newPageUrl);
        })
      .catch((err) => {
        if(this.componentDestroyed) return;
        console.error(err);
        this.searching = false;
        this.clientIntakes = [];
        this.count = 0;
        this.notyService.notify('Error loading client intakes', 'error');
      });
  }

  unlockClientIntake(clientIntake: any) {
    if(this.componentDestroyed) return Promise.resolve();
    return this.clientIntakeService.unlock(clientIntake.id).then(unlockRe=>{
      if(this.componentDestroyed) return;
      console.log("unlock client response", unlockRe)
      clientIntake.locked = false;
      this.search();
      this.notyService.notify('Client Intake unlocked', 'warning');
    }).catch(unlockErr=>{
      if(this.componentDestroyed) return;
      console.log("unlock client error", unlockErr)
      this.notyService.notify('Error unlocking client Intake', 'error');
    })
  }

  // Positioning events and methods
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  content_sidebar_scroll() {
    if(this.componentDestroyed) return;
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    if(this.componentDestroyed) return;
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 95;
    }
  }
}
